/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Mention_EveryoneInputs */



/**
* | output |
* | --- |
* | "Mention @everyone, @here and All Roles" |
*
* @param {Leveling_Perm_Mention_EveryoneInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_mention_everyone = /** @type {((inputs?: Leveling_Perm_Mention_EveryoneInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Mention_EveryoneInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Упоминание @everyone, @here и всех ролей")
	return /** @type {LocalizedString} */ ("Mention @everyone, @here and All Roles")
});